import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["roof-maintenance"];

export const Route = createFileRoute("/services/roof-maintenance")({
  head: () => ({
    meta: [
      { title: "Roof Maintenance Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Regular roof maintenance in Southern California – resealing, flashing checks and small repairs handled before they turn into big ones." },
      { property: "og:title", content: "Roof Maintenance – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/roof-maintenance" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});